import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { UsersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseUserGetProps {
  id: number;
}

export const useUserGet = (
  { id }: IUseUserGetProps,
  options?: { enabled?: boolean },
) => {
  const accessToken = useAccessToken();

  const { data, isSuccess, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.UserGet, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(UsersApi, accessToken);
      return service.apiUsersIdGet({
        id: id,
      });
    },
    enabled: options?.enabled !== false && id > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isSuccess,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
